import { useNavigate, useSearchParams } from 'react-router-dom';
import styled from 'styled-components';
import { useAuth } from '../../context/AuthContext';

const PaymentFail = () => {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const { role } = useAuth();
  const code = params.get('code') || '';
  const message = params.get('message') || '결제가 취소되었거나 실패했습니다.';

  const handleBack = () => {
    if (window.history.length > 1) {
      navigate(-1);
    } else if (role === 'partner') {
      navigate('/partner/payment', { replace: true });
    } else {
      navigate('/', { replace: true });
    }
  };

  const handlePaymentList = () => {
    if (role === 'partner') {
      navigate('/partner/payment', { replace: true });
    } else {
      navigate('/', { replace: true });
    }
  };

  return (
    <Wrap>
      <Card>
        <Title>결제 실패</Title>
        <Desc>{message}{code && ` (${code})`}</Desc>
        <BtnRow>
          <BtnGhost onClick={handleBack}>뒤로가기</BtnGhost>
          <BtnPrimary onClick={handlePaymentList}>결제 목록으로</BtnPrimary>
        </BtnRow>
      </Card>
    </Wrap>
  );
};

export default PaymentFail;

const Wrap = styled.div`
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #F6F8FA;
  padding: 24px;
`;
const Card = styled.div`
  width: 100%;
  max-width: 420px;
  background: #fff;
  border-radius: 16px;
  padding: 32px 24px;
  text-align: center;
`;
const Title = styled.h2`
  font-size: 20px;
  font-weight: 700;
  margin: 0 0 12px;
  color: #DC2626;
`;
const Desc = styled.p`
  font-size: 14px;
  color: #6B7280;
  line-height: 1.6;
  margin: 0 0 24px;
`;
const BtnRow = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;
`;
const BtnBase = styled.button`
  padding: 12px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;
`;
const BtnGhost = styled(BtnBase)`
  background: #fff;
  color: #1F2937;
  border: 1px solid #E5E7EB;
`;
const BtnPrimary = styled(BtnBase)`
  background: #4A6CF7;
  color: #fff;
  border: 0;
`;
